
<div class="page-header">
    <a routerLink="/relatie-typen/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "relation-type.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-relation-type-detail-form [relationType]="relationType$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>